import { shark, white } from '@ifit/base-coat/js/colors';
import DotsLoading from '@ifit/mp-dots-loading';
import { ThemeContext } from '@ifit/themes/ThemeContext';
import { useContext } from 'react';
import { getUserNavigationHandler } from '../../util/navigation-utils';
import { Text } from './text';
import './index.scss';

interface IRowHeadingProps {
  title: string;
  fetching?: boolean;
  link?: string;
}

const dotColors = {
  LIGHT: {
    color: shark,
  },
  DARK: {
    color: white,
  },
  VAULT: {
    color: shark,
  },
};

export default function RowHeading({ title, fetching, link }: IRowHeadingProps): JSX.Element {
  const clickHandler = getUserNavigationHandler(link);
  const { theme } = useContext(ThemeContext);

  return (
    <div className="row-container">
      <h2 className="row-title">
        {title}
        {fetching && (
          <DotsLoading className="dots-loading" data-testid="loading-dots" color={dotColors[theme].color} size={4} />
        )}
      </h2>
      {link && (
        <a href={`#${link}`} onClick={clickHandler} className="row-link">
          {Text.viewAll}
        </a>
      )}
    </div>
  );
}
